<template>
  <div>
    <v-row>
      <v-col class="pb-0">
        <span class="display-1">Payment Amount: 
          <v-progress-circular :value="20" :indeterminate="true" v-if="payment_amount == null"></v-progress-circular>
          <span v-else>${{ payment_amount | formatCurrency }}</span>
        </span>
        <v-btn target="_blank" href="https://www.irs.gov/pub/irs-pdf/fw9.pdf" class="float-right">Download a Blank W9 Form</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="payment_breakdowns"
            class="elevation-1"
            :loading="loading_table"
            hide-default-footer
          >
            <template v-slot:item.id_vendor_assignment="{ item }">
              <v-btn target="_blank" :href="`https://images.opustools.com/image.php?table=vendor_assignment&id=${item.id_vendor_assignment}&field=document`" text color="primary">View</v-btn>
            </template>
            <template v-slot:item.id="{ item }">
              <v-btn text color="primary" @click="edit(item.id)">Edit</v-btn>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-btn color="primary" @click="create()">Create Payment Breakdown</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Dialog @reloadtable="loadTable" @loadingdialog="loadingDialog" @closedialog="closeDialog" :payment_breakdowns="payment_breakdowns" :payment_amount="payment_amount" :vendor_id="vendor_id" :item_id="item_id" :dialog="dialog" :loading_dialog="loading_dialog"/>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import Dialog from './Finance/Dialog'

export default {
  components: {
    Dialog
  },
  data() {
    return {
      item_id: 0,
      payment_amount: null,
      loading_table: true,
      loading_dialog: false,
      payment_breakdowns: [],
      dialog: false,
      vendor_id: 0,
      headers: [
        { text: 'Payee', value: 'payee_manual' },
        { text: 'Amount', value: 'amount' },
        { text: 'W9', value: 'id_vendor_assignment' },
        { text: '', align: 'right', value: 'id' }
      ]
    }
  },
  methods: {
    edit(id) {
      this.item_id = Number(id)
      this.dialog = true
    },
    create() {
      this.item_id = 0
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.loading_dialog = false
    },
    loadingDialog() {
      this.loading_dialog = true
    },
    // saveInfo(id, payee, amount) {
    //   // if(this.paymentBreakdownsSum + amount > this.payment_amount) {
    //   //   return
    //   // }

    //   const vm = this
    //   const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

    //   const method = id == 0 ? 'post' : 'put'
    //   let data = {
    //     Amount: amount,
    //     Payee_Manual: payee,
    //     ID_Vendor_Assignment: vm.$store.state.assignment,
    //     ID_Vendor: vm.vendor_id
    //   }
    //   if(id != 0) { data.id = id }

    //   vm.loading_dialog = true
    //   putOpusApi({
    //     method: method,
    //     table: 'vendor_assignment_payment_breakdowns',
    //     params: data
    //   }).then(function() {
    //     vm.dialog = false
    //     vm.loading_dialog = false
    //     vm.loadTable()
    //   })
    // },
    loadTable() {
      const vm = this
      const id = vm.$store.state.assignment
      const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

      vm.loading_table = true
      getOpusApi({
        table: `vendor_assignments/${id}`,
        params: {
          include: 'vendor_assignment_payment_breakdowns,vendor'
        }
      }).then(function(response) {
        // console.log(response.data.result.performance_site.id)
        if(response.data.result.vendor) {vm.vendor_id = parseInt(response.data.result.vendor.id)}
        if(response.data.result.performance_site) {
          const site_id = response.data.result.performance_site.id
          vm.payment_breakdowns = response.data.result.vendor_assignment_payment_breakdowns
          getOpusApi({
            table: `performance_slot_utilization_news/${site_id}`
          }).then(function(response) {
            // console.log(response)
            vm.payment_amount = response.data.result.total_site_host_payment
          })
        }
        else {
          vm.payment_amount = 0
        }
        vm.loading_table = false
      })
    }
  },
  filters: {
    formatCurrency(amount) {
      return amount.toFixed(2)
    }
  },
  mounted() {
    this.loadTable()
  }
}
</script>